import Flickity from 'flickity'
import { $, each } from '../util'

const PartnersSlider = (() => {
  const init = () => {
    const container = $('.js-partners-slider-container')

    each(container, (i, ct) => {
      const partnersSlider = ct.querySelector('.js-partners-slider')

      const partnersInstance = new Flickity(partnersSlider, {
        cellSelector: '.js-partners-slide',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        prevNextButtons: false,
        wrapAround: true,
        // draggable: false,
        autoPlay: false,
        pauseAutoPlayOnHover: true,
      })
    })
  }

  return {
    init,
  }
})()

export default PartnersSlider



// WEBPACK FOOTER //
// app/javascript/scripts/components/PartnersSlider.js